'use client';

import type { ReactNode } from 'react';
import { useUTMPersistence } from '@/hooks/useUTMPersistence';

/**
 * Activates UTM persistence for the subtree.
 *
 * Drop this inside any client-side provider tree to automatically:
 *  - Capture UTM / ref query-params from landing URLs
 *  - Persist them in cookies for 30 days
 *  - Re-append them to internal links on every route change
 */
export function UTMProvider({ children }: { children: ReactNode }) {
  useUTMPersistence();
  return <>{children}</>;
}
